import React, { useEffect } from "react";
import { Form, Button, Card } from "react-bootstrap";

function AnalysisForm({
    categoria, commessa, reparto, tipologiaVista,
    setCategoria, setCommessa, setReparto, setTipologiaVista,
    categorieOptions, commesseOptions, repartiOptions,
    onSubmit, disabled = false
}) {

    // Reset commessa if categoria ≠ "specific"
    useEffect(() => {
        if (categoria !== "specific") {
            setCommessa("");
        }
    }, [categoria, setCommessa]);

    // Gestione logica vista + reparto in base alla categoria
    useEffect(() => {

        // Se categoria = ALL → vista solo "categoria"
        if (categoria === "all") {
            if (tipologiaVista !== "categoria") {
                setTipologiaVista("categoria");
            }
            setReparto(""); // nascondi e resetta reparto
        }

        // Se categoria diversa da ALL → vista {reparto, persone}
        if (categoria && categoria !== "all") {
            if (tipologiaVista === "categoria") {
                setTipologiaVista(""); // disabilita categoria
            }
        }

    }, [categoria, tipologiaVista, setTipologiaVista, setReparto]);

    return (
        <Card className="shadow-sm border-0">
            <Card.Body className="p-4">

                <Card.Title className="mb-4 text-center fw-semibold">
                    <h6>-- INFORMAZIONI DA INSERIRE --</h6>
                </Card.Title>

                <Form onSubmit={onSubmit}>

                    {/* --- Categoria --- */}
                    <Form.Group className="mb-3">
                        <Form.Label><strong>Categoria</strong></Form.Label>
                        <Form.Select
                            value={categoria}
                            required
                            onChange={(e) => setCategoria(e.target.value)}
                        >
                            <option value="">-- Seleziona Categoria --</option>
                            <option value="all">Tutte le categorie</option>
                            <option value="specific">Specifica commessa</option>
                            <option disabled>────────────────────</option>
                            {categorieOptions.map((c) => (
                                <option key={c} value={c}>{c}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    {/* --- Commessa --- */}
                    {categoria === "specific" && (
                        <Form.Group className="mb-3">
                            <Form.Label><strong>Commessa</strong></Form.Label>
                            <Form.Select
                                value={commessa}
                                required
                                onChange={(e) => setCommessa(e.target.value)}
                            >
                                <option value="">-- Seleziona Commessa --</option>
                                {commesseOptions.map((c) => (
                                    <option key={c} value={c}>{c}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    )}

                    {/* --- Reparto: VISIBILE SOLO SE categoria ≠ all --- */}
                    {categoria !== "" && (
                        <Form.Group className="mb-3">
                            <Form.Label><strong>Reparto</strong></Form.Label>
                            <Form.Select
                                value={reparto}
                                required
                                onChange={(e) => setReparto(e.target.value)}
                            >
                                <option value="">-- Seleziona Reparto --</option>
                                <option value="all">Tutti i reparti</option>
                                <option disabled>────────────────────</option>
                                {repartiOptions.map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    )}

                    {/* --- Tipologia Vista --- */}
                    {categoria !== "" && (
                        <Form.Group className="mb-4">
                            <Form.Label><strong>Vista</strong></Form.Label>
                            <Form.Select
                                value={tipologiaVista}
                                required
                                onChange={(e) => setTipologiaVista(e.target.value)}
                            >
                                <option value="">-- Seleziona Vista --</option>

                                {/* Categoria ALL → solo "categoria" */}
                                {categoria === "all" && (
                                    <option value="categoria">Categoria</option>
                                )}

                                {/* Categoria ≠ ALL → reparto + persone */}
                                {categoria !== "all" && categoria !== "" && (
                                    <>
                                        <option value="reparto">Reparto</option>
                                        <option value="persone">Persona</option>
                                    </>
                                )}

                            </Form.Select>
                        </Form.Group>
                    )}   

                    <div className="d-grid">
                        <Button type="submit" variant="primary" size="lg" disabled={disabled}>
                            {disabled ? "Elaborazione..." : "ANALISI"}
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}

export default AnalysisForm;
